import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState<string | null>(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setActiveAccordion(null); // 메뉴 닫을 때 아코디언도 초기화
  };

  const toggleAccordion = (accordionName: string) => {
    setActiveAccordion(activeAccordion === accordionName ? null : accordionName);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setActiveAccordion(null);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="nav-brand">
          <Link to="/">
            <img 
              src="/logo.png" 
              alt="청소년 스마트폰 프리 운동, Smartphone-Free Childhood Movement" 
              className="logo"
            />
          </Link>
        </div>
        <button className="mobile-menu-btn" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <div className="nav-dropdown">
            <a 
              href="#about" 
              className="nav-accordion-trigger"
              onClick={(e) => {
                e.preventDefault();
                toggleAccordion('about');
              }}
            >
              운동본부 소개
              <span className={`accordion-icon ${activeAccordion === 'about' ? 'active' : ''}`}>›</span>
            </a>
            <div className={`dropdown-content accordion-content ${activeAccordion === 'about' ? 'active' : ''}`}>
              <Link to="/greeting" onClick={closeMenu}>인사말</Link>
              <Link to="/vision" onClick={closeMenu}>설립취지 및 비전</Link>
              <Link to="/history" onClick={closeMenu}>창립 경과보고</Link>
              <Link to="/organization" onClick={closeMenu}>조직도</Link>
              <Link to="/office" onClick={closeMenu}>사무국 안내</Link>
            </div>
          </div>
          <Link to="/smartphone-free" onClick={closeMenu} className="nav-link">스마트폰프리운동</Link>
          <Link to="/activities" onClick={closeMenu} className="nav-link">주요 활동</Link>
          <div className="nav-dropdown">
            <a 
              href="#media" 
              className="nav-accordion-trigger"
              onClick={(e) => {
                e.preventDefault();
                toggleAccordion('media');
              }}
            >
              언론 & 자료
              <span className={`accordion-icon ${activeAccordion === 'media' ? 'active' : ''}`}>›</span>
            </a>
            <div className={`dropdown-content accordion-content ${activeAccordion === 'media' ? 'active' : ''}`}>
              <Link to="/press-release" onClick={closeMenu}>보도자료</Link>
              <Link to="/media-coverage" onClick={closeMenu}>언론보도</Link>
              <Link to="/resources" onClick={closeMenu}>자료실</Link>
            </div>
          </div>
          <Link to="/notice" onClick={closeMenu} className="nav-link">공지사항</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header; 